module.exports = __webpack_public_path__ + "img/qr-sample.9581047f.svg";